export default {
  ZH_HK: {
    search: "搜索",
    no_data: "沒有合適的圖片",
    title: "智能選圖"
  },
  EN: {
    search: "Search",
    no_data: "Empty",
    title: "AI Photo"
  },
  zh_cn: {
    search: "搜索",
    no_data: "没有合适的图片",
    title: "智能选图"
  },
  es: {
    search: "Buscar",
    no_data: "Vacío",
    title: "Foto IA"
  }
};
